import styled from 'styled-components';

export const ConfirmTransferModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 10px auto;
  flex: 1 0 auto;
  min-width: 250px;
`;

export const ProgressContainer = styled.div`
  margin: 1rem 0;
  width: 100%;
`;

export const BatchStatus = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 1rem 0;
  gap: 1rem;
`;

export const StatusItem = styled.div`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background-color: ${props => props.success ? '#d4edda' : props.error ? '#f8d7da' : '#d1ecf1'};
  color: ${props => props.success ? '#155724' : props.error ? '#721c24' : '#0c5460'};
  font-weight: 600;
`;

export const ResultsList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  margin-top: 1rem;
  width: 100%;
`;

export const ResultItem = styled.div`
  padding: 0.25rem 0.5rem;
  margin: 0.25rem 0;
  font-size: 12px;
  color: ${props => props.success ? '#155724' : '#721c24'};
  text-align: left;
`;
